/**
 * @module:  Jsbridge入口文件
 * @author: Liang Huang
 * @date: 2019-09-17 14:01:18
 */
import mixin from './mixin';
import authMixin from './api/native/auth';
import deviceMixin from './api/native/device';
import runtimeMixin from './api/native/runtime';
import statusbarMixin from './api/native/statusbar';
import pageMixin from './api/native/page';
import uiMixin from './api/native/ui';
import utilMixin from './api/native/util';
var hybridJs = window.YwkHybrid = {};
mixin(hybridJs);
authMixin(hybridJs);
deviceMixin(hybridJs);
runtimeMixin(hybridJs);
statusbarMixin(hybridJs);
pageMixin(hybridJs);
uiMixin(hybridJs);
utilMixin(hybridJs);
hybridJs.Version = '1.0.0';
export default hybridJs;